import { render, staticRenderFns } from "./InvitesSentModal.vue?vue&type=template&id=5dd0aa1b&scoped=true"
import script from "./InvitesSentModal.vue?vue&type=script&lang=js"
export * from "./InvitesSentModal.vue?vue&type=script&lang=js"
import style0 from "./InvitesSentModal.vue?vue&type=style&index=0&id=5dd0aa1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0aa1b",
  null
  
)

export default component.exports